export var Browsers = {
  rO: "Chrome",
  eO: "Edge",
  oO: "Opera",
  Bg: "Safari",
  OO: "Firefox"
};
export var OperatingSystems = {
  xg: "Android",
  ao: "iOS",
  Pg: "Mac",
  Og: "Windows"
};